import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderText } from './HeaderText';
import { EntryPoint, EntryPointProp, SearchSegment } from '../../../../../models';

export const HeaderLocation = ({ segment, activeProduct }) => {
    const { t } = useTranslation();
    const isHotel = activeProduct === EntryPoint.HOTELS;
    const { origin, destination } = segment;

    let text = '';
    if (origin && destination) {
        text = t('flightsManager.selection.header.locations', {
            from: origin.iata,
            to: destination.iata,
        });
    } else if (origin) {
        text = t('flightsManager.selection.header.from', { from: origin.iata });
    } else if (destination) {
        text = t('flightsManager.selection.header.to', { to: isHotel? destination.name : destination.iata });
    }

    return (
        text && (
            <div className="odf-text-center">
                <HeaderText text={text} />
            </div>
        )
    );
};

HeaderLocation.propTypes = {
    segment: SearchSegment.isRequired,
    activeProduct: EntryPointProp.isRequired,
};
